import { SvrConn, SvrConnIm } from "../utils/axios/index";
//----------------------------------------------------------------------------------------------------------------------
export const getArchivosImgAll = async (grupo) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/archive/getarchiveall",{grupo});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
//----------------------------------------------------------------------------------------------------------------------
 export const getMessageImgxArea = async (grupo, area) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/archive/getarchiveallxarea",{grupo, area});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
//----------------------------------------------------------------------------------------------------------------------
  export const setBloqueaArchivo = async (AreaId,ArchivoId, TagId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/archive/setbloqueaarchive", { AreaId,ArchivoId, TagId });
    } catch (Error) {
      res = Error;
    }
    return res;
  };
//----------------------------------------------------------------------------------------------------------------------
 export const getArchiveInt = async (area, archivoId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/archive/getarchiveint",{area, archivoId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
//----------------------------------------------------------------------------------------------------------------------
  export const actualizaArchive = async(data)=>{
    let res = {};
      try {
        res = await SvrConn.post("/api/archive/setactualizaarchive", data);
      } catch (Error) {
        res = Error;
      }
      return res;
  }
//----------------------------------------------------------------------------------------------------------------------
  export const getArchiveDet = async (ArchivoId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/archive/getarchiveDet",{ArchivoId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
//----------------------------------------------------------------------------------------------------------------------
export const getArchiveDetInt = async (ArchivoId, ItemId) => {
    let res = {};
    try {
      console.log(ArchivoId);
      console.log(ItemId);
      res = await SvrConn.post("/api/archive/getarchivedetint",{ArchivoId, ItemId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };  
//----------------------------------------------------------------------------------------------------------------------
export const setuploadimage = async( files, descripcion, ArchivoId, Tag,Tipo)=>{
  let res = {};
    try {
      const formData = new FormData();
      formData.append("files", files); // 👈 este es el archivo
      formData.append("descripcion", descripcion);
      formData.append("ArchivoI", ArchivoId);
      formData.append("Tag", Tag);
      formData.append("Tipo", Tipo);

      res = await SvrConnIm.post("/api/upload/setuploadarchive", formData
        );
    } catch (Error) {
      res = Error;
    }
    return res;
}

//----------------------------------------------------------------------------------------------------------------------
export const setuploadvideo = async(files, descripcion, ArchivoId, Tag, Tipo)=>{
  let res = {};
    try {
      const formData = new FormData();
      formData.append("files", files); //  este es el archivo
      formData.append("descripcion", descripcion);
      formData.append("ArchivoI", ArchivoId);
      formData.append("Tag", Tag);
      formData.append("Tipo", Tipo);

      res = await SvrConnIm.post("/api/upload/setuploadvideo", formData
        );
    } catch (Error) {
      res = Error;
    }
    return res;
}
//----------------------------------------------------------------------------------------------------------------------
export const setArchiveDetInt = async (ArchivoId, ItemId, descripcion) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/archive/setarchivedetint",{ArchivoId, ItemId, descripcion});
    } catch (Error) {
      res = Error;
    }
    return res;
  };  


